/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LoanTierDto } from './LoanTierDto';
import {
    LoanTierDtoFromJSON,
    LoanTierDtoFromJSONTyped,
    LoanTierDtoToJSON,
    LoanTierDtoToJSONTyped,
} from './LoanTierDto';

/**
 * 
 * @export
 * @interface CreateLoanDto
 */
export interface CreateLoanDto {
    /**
     * Unique identifier for the loan
     * @type {string}
     * @memberof CreateLoanDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanDto
     */
    borrowerProjectId?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    loanAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    insuranceAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    totalDuration?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanDto
     */
    interestRateTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    interestRatePercentage: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanDto
     */
    loanTypeId: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    defermentPeriod: number;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanDto
     */
    defermentTypeId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLoanDto
     */
    interestRepayment?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    remainingDuration?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    rentAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateLoanDto
     */
    residualValue?: number;
    /**
     * 
     * @type {Array<LoanTierDto>}
     * @memberof CreateLoanDto
     */
    tiers?: Array<LoanTierDto>;
}

/**
 * Check if a given object implements the CreateLoanDto interface.
 */
export function instanceOfCreateLoanDto(value: object): value is CreateLoanDto {
    if (!('loanAmount' in value) || value['loanAmount'] === undefined) return false;
    if (!('interestRateTypeId' in value) || value['interestRateTypeId'] === undefined) return false;
    if (!('interestRatePercentage' in value) || value['interestRatePercentage'] === undefined) return false;
    if (!('loanTypeId' in value) || value['loanTypeId'] === undefined) return false;
    if (!('defermentPeriod' in value) || value['defermentPeriod'] === undefined) return false;
    if (!('defermentTypeId' in value) || value['defermentTypeId'] === undefined) return false;
    return true;
}

export function CreateLoanDtoFromJSON(json: any): CreateLoanDto {
    return CreateLoanDtoFromJSONTyped(json, false);
}

export function CreateLoanDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLoanDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'borrowerProjectId': json['borrowerProjectId'] == null ? undefined : json['borrowerProjectId'],
        'loanAmount': json['loanAmount'],
        'insuranceAmount': json['insuranceAmount'] == null ? undefined : json['insuranceAmount'],
        'totalDuration': json['totalDuration'] == null ? undefined : json['totalDuration'],
        'interestRateTypeId': json['interestRateTypeId'],
        'interestRatePercentage': json['interestRatePercentage'],
        'loanTypeId': json['loanTypeId'],
        'defermentPeriod': json['defermentPeriod'],
        'defermentTypeId': json['defermentTypeId'],
        'interestRepayment': json['interestRepayment'] == null ? undefined : json['interestRepayment'],
        'remainingDuration': json['remainingDuration'] == null ? undefined : json['remainingDuration'],
        'rentAmount': json['rentAmount'] == null ? undefined : json['rentAmount'],
        'residualValue': json['residualValue'] == null ? undefined : json['residualValue'],
        'tiers': json['tiers'] == null ? undefined : ((json['tiers'] as Array<any>).map(LoanTierDtoFromJSON)),
    };
}

export function CreateLoanDtoToJSON(json: any): CreateLoanDto {
    return CreateLoanDtoToJSONTyped(json, false);
}

export function CreateLoanDtoToJSONTyped(value?: CreateLoanDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'borrowerProjectId': value['borrowerProjectId'],
        'loanAmount': value['loanAmount'],
        'insuranceAmount': value['insuranceAmount'],
        'totalDuration': value['totalDuration'],
        'interestRateTypeId': value['interestRateTypeId'],
        'interestRatePercentage': value['interestRatePercentage'],
        'loanTypeId': value['loanTypeId'],
        'defermentPeriod': value['defermentPeriod'],
        'defermentTypeId': value['defermentTypeId'],
        'interestRepayment': value['interestRepayment'],
        'remainingDuration': value['remainingDuration'],
        'rentAmount': value['rentAmount'],
        'residualValue': value['residualValue'],
        'tiers': value['tiers'] == null ? undefined : ((value['tiers'] as Array<any>).map(LoanTierDtoToJSON)),
    };
}

